
<template>
    <AppMainDialogForm v-model="dialog" :isLoading="isLoading" size='700' :tituloTela="tituloTela" :tooltip="tooltip" 
        @initComponent="initComponent" @saveRegistro="saveRegistro" @cancel="cancel" :showButton="showButton">
        <v-form v-model="isFormValid" ref="formDialog" name="formDialog">
            <v-layout row justify-center class="fixedHeight">
                <v-flex class="item" xs5 lg5 md5>
                    <v-text-field :rules="[campoObrigatorio]" outlined clearable :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" 
                        :type="showPass ? 'text' : 'password'" @click:append="showPass = !showPass" v-model="dsNovaSenha" label="Nova senha"/>
                </v-flex>
                <v-flex class="item" xs5 lg5 md5>
                    <v-text-field :rules="[campoObrigatorio]" outlined clearable :append-icon="showConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showConfirmation ? 'text' : 'password'" @click:append="showConfirmation = !showConfirmation" v-model="dsConfirmacaoSenha" label="Confirme a senha"/>
                </v-flex>
            </v-layout>
        </v-form>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio } from '@/filters/rules'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'

    export default {
        components: {
            AppMainDialogForm,
        },
        computed: {
            tooltip() {
                return 'Alteração de senha do Usuário'
            },
            tituloTela() {
                return 'Alteração de senha do Usuário'
            },
            urlAPIEstabelecimento() {
                return this.$store.state.urlAPIEstabelecimento
            },
        },
        data () {
            return {
                isFormValid: false,
                isLoading: false,
                registro: {},
                showButton: false,
                dsSenhaAtual: '',
                dsNovaSenha: '',
                dsConfirmacaoSenha: '',
                showPass: false,
                showConfirmation: false,
            }
        },
        methods: {
            campoObrigatorio,
            initComponent() {
                if (this.$refs.formDialog != undefined)
                {
                    this.$refs.formDialog.reset()
                }
                if (this.rec != [])
                {
                    this.registro = this.rec
                }
                this.isSaved = false
                this.$emit('openDialog')
            },
            saveRegistro() {
                if (this.$refs.formDialog.validate())
                {
                    this.isLoading = true
                    this.registro.dsPassword = this.dsNovaSenha
                    this.$axios.put(this.urlAPIEstabelecimento + 'usuario/resetSenha/' + this.registro.idUsuario, this.registro)
                        .then(() => {
                            this.$emit('closeDialog')
                            this.$store.commit('setSnack', {type: 'success', msg: 'Senha alterada com sucesso!'})
                        })
                        .catch((error) => {
                            this.$store.commit('setSnack', {type: 'error', msg: error})
                        })
                        .finally(() => {
                            this.isLoading = false
                        })
                }
            },
            cancel() {
                this.$emit('closeDialog')
            },
        },
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            rec: {
                type: Object,
                default: []
            }
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .inputPrice input[type='number'] {
        -moz-appearance:textfield;
    }
    .inputPrice input::-webkit-outer-spin-button,
    .inputPrice input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    .fixedHeight {
        height: 80px;
    }
    .layoutOrdemConsumo {
        margin: 1%; 
        font-size: 15px;
    }
</style>
